(() => {
  const feedbackTimers = new WeakMap();
  const setButtonState = (button, state, message = '') => {
    if (!button?.hasAttribute('data-sk-cart-feedback')) return;
    clearTimeout(feedbackTimers.get(button));
    const title = button.dataset.productTitle;
    const label = button.querySelector('.sk-card-add__label');
    const status = button.closest('form').querySelector('[data-sk-cart-status]');
    button.dataset.cartState = state;
    button.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
    label.textContent = { idle: 'Add', loading: 'Adding', added: 'Added', error: 'Retry' }[state];
    button.setAttribute('aria-label', state === 'added' ? `${title} added to cart. Add another` : `Add ${title} to cart`);
    if (status) {
      status.textContent = state === 'added' ? `${title} added to your cart.` : state === 'error' ? message || 'Could not add this item. Please try again.' : '';
      status.classList.toggle('visually-hidden', state !== 'error');
      status.classList.toggle('sk-card-add__error', state === 'error');
    }
    if (state === 'added') feedbackTimers.set(button, setTimeout(() => setButtonState(button, 'idle'), 8000));
  };

  const addItems = async (items, trigger) => {
    setButtonState(trigger, 'loading');
    try {
      const drawer = document.querySelector('cart-drawer');
      const payload = { items };
      if (drawer) {
        payload.sections = drawer.getSectionsToRender().map(section => section.id);
        payload.sections_url = window.location.pathname;
        drawer.setActiveElement(trigger || document.activeElement);
      }
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add this item.');
      if (drawer && state.sections) {
        drawer.renderContents(state);
        drawer.classList.remove('is-empty');
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: state }));
      setButtonState(trigger, 'added');
      return state;
    } catch (error) {
      setButtonState(trigger, 'error', error.message || 'Could not add this item. Please try again.');
      throw error;
    }
  };

  window.SakazaCart = { addItems, setButtonState };

  document.addEventListener('submit', event => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form || form.closest('product-form')) return;
    event.preventDefault();
    const data = new FormData(form);
    const id = data.get('id');
    if (!id) return;
    const button = form.querySelector('[type="submit"]');
    if (button?.disabled) return;
    if (button) button.disabled = true;
    addItems([{ id, quantity: Number(data.get('quantity') || 1) }], button)
      .catch(console.error)
      .finally(() => { if (button) button.disabled = false; });
  });
})();
